<template>
	<div class="child_indexBox">
		<template v-if="isPro">
			<div class="child_nav">
				<div class="nav_top">
					<span class="cTitBox">Weekly Forecast</span>
					<transition name="fade" mode="out-in">
						<i v-if="showWeekly" key="show" class="el-icon-arrow-up myUp_icon" @click="showWeekly=false"></i>
						<i v-if="!showWeekly" key="hide" class="el-icon-arrow-down myUp_icon" @click="showWeekly=true"></i>
					</transition>
				</div>
				<el-collapse-transition>
					<div class="nav_body" v-if="showWeekly">
						<ul class="navBody_t" key="1">
							<li class="navBody_tit">Total Hours</li>
							<li class="navBody_tit">Total Salaried</li>
							<li class="navBody_tit">Total Casual</li>
							<li class="navBody_tit">Total Cost</li>
						</ul>
						<ul class="navBody_f" key="2">
							<li class="navBody_tmsg">{{weeklyForecast.hours}}</li>
							<li class="navBody_tmsg">{{weeklyForecast.salaried}}</li>
							<li class="navBody_tmsg">{{weeklyForecast.casual}}</li>
							<li class="navBody_tmsg">{{weeklyForecast.cost!='-'?`$${weeklyForecast.cost}`:'-'}}</li>
						</ul>
					</div>
				</el-collapse-transition>
			</div>
			<div>
				<el-table
				:data="tableData"
				border
				class="roster_table"
				style="width: 100%">
					<el-table-column
					prop="dateStr"
					align="center"
					label-class-name="roster_th"
					class-name="roster_row"
					label="Week Ending">
					</el-table-column>
					<el-table-column
					prop="hours"
					align="center"
					label-class-name="roster_th"
					class-name="roster_row"
					label="Hours">
					</el-table-column>
					<el-table-column
					prop="salaried"
					align="center"
					label-class-name="roster_th"
					class-name="roster_row"
					label="Salaried">
					</el-table-column>
					<el-table-column
					prop="casual"
					align="center"
					label-class-name="roster_th"
					class-name="roster_row"
					label="Casual">
					</el-table-column>
					<el-table-column
					prop="cost"
					align="center"
					label-class-name="roster_th"
					class-name="roster_row"
					label="Cost">
						<template slot-scope="scope">
							<div>
								${{scope.row.cost}}
							</div>
						</template>
					</el-table-column>
					<template slot="empty">
						<i v-if="load" class="el-icon-loading" style="font-size:20px"></i>
						<div v-else style="font-size:18px">No Data</div>
					</template>
				</el-table>
				<div class="ros_footerPage">
					<el-pagination
						class="my_pageSel"
						@current-change='changePage'
						layout="prev, pager, next"
						:page-size="10"
						:current-page.sync='page'
						:total="total">
					</el-pagination>
				</div>
			</div>
		</template>
		
		<template v-if="isDoneLoad && !isPro">
		   <div class="error-container d-flex justify-content-center align-items-center">
				<card-unauthorized></card-unauthorized>
		   </div>
		</template>
	</div>
</template>

<script>
import api from '../../api/api'
import cardUnauthorized from '@/components/card/unauthorized';
export default {
	data() {
		return {
			showWeekly:true,
			tableData:[],
			total:1,
			page:1,
			size:10,
			load:false,
			weeklyForecast:{
				casual:'-',
				cost:'-',
				hours:'-',
				salaried:'-'
			}
		}
	},
	components: {
		cardUnauthorized: cardUnauthorized
	},
	props: {
		time: {
			default: null
		},

		isPro: {
			default: null
		},
		isDoneLoad: {
			default: null
		}
	},
	mounted () {
		this.getlist()

        this.$router.push('/rosterAndlabourlabour')
	},
	watch:{
		time(n,o){
			this.getlist()
		},
	},
	methods: {
		changePage(page){
			this.page = page
			this.getlist()
		},
		getlist(){
			this.load = true
			let pat={
                pageNum:this.page,
				pageSize:this.size,
				beginDate:this.time?Date.parse(this.time[0])/1000:'',
				endDate:this.time?Date.parse(this.time[1])/1000:''
            }
            api.getWeeklyForecastList(pat,res=>{
				this.load = false
                let {code,data,message}=res.data;
                if(code==0){
					if(data.weeklyForecast!=null){
						this.weeklyForecast = data.weeklyForecast
						this.weeklyForecast.casual = Utils.formatSplit(this.weeklyForecast.casual)
						this.weeklyForecast.cost = Utils.formatSplit(this.weeklyForecast.cost)
						this.weeklyForecast.hours = Utils.formatSplit(this.weeklyForecast.hours)
						this.weeklyForecast.salaried = Utils.formatSplit(this.weeklyForecast.salaried)
					}
					
					this.tableData=data.deputyRosterList.data.list;
					this.tableData.forEach(item=>{
						item.casual = Utils.formatSplit(item.casual)
						item.cost = Utils.formatSplit(item.cost)
						item.hours = Utils.formatSplit(item.hours)
						item.salaried = Utils.formatSplit(item.salaried)
						// item.date = Utils.timeFotmatYMD(item.date*1000)
						item.date = Utils.formatDateMonthyear3(item.date)
					})
                    this.total=data.deputyRosterList.data.total;
                }else{
                    Utils.alert('',message,'error')
                }
            })
		}
	},
}
</script>

<style lang="scss" scoped>
	.child_indexBox{
		width: 100%;
		margin-top: 30px;
		.child_nav{
			background-color: var(--background-color-3);
			margin-bottom: 30px;
			.nav_top{
				box-sizing: border-box;
				padding:21px 30px;
				display: flex;
				.cTitBox{
					height:28px;
					font-size:20px;
					font-family:PingFang SC;
					font-weight:600;
					color:var(--text-color);
					line-height:28px;
				}
				.myUp_icon{
					font-size:20px;
					cursor: pointer;
					color: var(--text-color);
					margin-left: auto;
				}
			}
			.nav_body{
				height: 100%;
				opacity: 1;
				.navBody_t{
					display: flex;
					height: 50px;
					justify-content: center;
					align-items: center;
					border:  1px solid #5c5c5d !important;
					.navBody_tit{
						flex: 1;
						height:22px;
						font-size:16px;
						font-weight:600;
						color:var(--text-color);
						line-height:22px;
						text-align: center;
					}
				}
				.navBody_f{
					display: flex;
					height: 60px;
					justify-content: center;
					align-items: center;
					border-bottom:  1px solid #5c5c5d !important;
					.navBody_tmsg{
						flex: 1;
						height:100%;
						font-size:24px;
						font-weight:500;
						color:var(--text-color);
						line-height:60px;
						text-align: center;
						border-left:  1px solid #5c5c5d !important;
						&:last-child{
							border-right:  1px solid #5c5c5d !important;
						}
					}
				}
			}
		}
		.ros_footerPage{
			display: flex;
			justify-content: center;
		}
		padding-bottom: 50px;
    }
    
    .draw-f-enter-active, .draw-f-leave-active {
        transition: all .2s ease;
        height: 116px;
        opacity: 1;
    }
    .draw-f-enter, .draw-f-leave-to {
        height: 0 !important;
        opacity: 0 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/rosterAndLabour/roster.vue